import { render } from "./ContasLocalidadeChart.vue?vue&type=template&id=6820bba1"
import script from "./ContasLocalidadeChart.vue?vue&type=script&lang=js"
export * from "./ContasLocalidadeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__